import { useTranslation } from 'react-i18next'

import LoginOrRegister from '@features/auth/ui/form/login-or-register'
import { useModalStore } from '@features/modal'


export default function useLoginModal () {
  const { t: ta } = useTranslation('auth')
  const { openModal, closeModal } = useModalStore()

  const openLoginModal = (onCloseCallback?: () => void) =>
    openModal('loginOrRegister', <LoginOrRegister />, {
      title: ta('login.title'),
      onClose: () => {
        if (onCloseCallback) {
          onCloseCallback()
        }
      },
    })

  const closeLoginModal = () => {
    closeModal('loginOrRegister')
  }

  return {
    openLoginModal,
    closeLoginModal,
  }
}
